import { useRef } from 'react'
import styled from 'styled-components'
import useDetailsViewDrop from '../../hooks/useDetailsViewDrop'
import { Colors, Dimensions, Spacing } from '../../styles'

const DetailsViewContainer = styled.div.attrs({ 'data-mobile-pane': 'detail' })`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.background.white};
    min-width: 300px;
    padding: ${Spacing._24};
    gap: ${Spacing._12};
    overflow: auto;
    color: ${Colors.text.ink};

    ${Dimensions.mediaQuery.phone} {
        min-width: 0;
        width: 100%;
        padding: ${Spacing._16} ${Dimensions.safeGutter(Spacing._12, 'right')}
            ${Dimensions.safeGutter(Spacing._16, 'bottom')} ${Dimensions.safeGutter(Spacing._12, 'left')};
        box-sizing: border-box;
        overscroll-behavior-y: contain;
    }
`

const DetailsViewTemplate = ({ children }: { children: React.ReactNode }) => {
    const detailsViewContainerRef = useRef<HTMLDivElement>(null)
    useDetailsViewDrop(detailsViewContainerRef)

    return <DetailsViewContainer ref={detailsViewContainerRef}>{children}</DetailsViewContainer>
}

export default DetailsViewTemplate
